import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Search, SlidersHorizontal } from "lucide-react";

const ALL_TYPE_TABS = [
  { value: "flight",  label: "FLIGHTS" },
  { value: "hotel",   label: "HOTELS" },
  { value: "cruise",  label: "CRUISES" },
  { value: "package", label: "PACKAGES" },
];

export default function FilterBar({ filters, setFilters }) {
  const [options, setOptions] = useState({ regions: [], from_countries: [], deal_types: [] });
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    api.get("/deals/filters/options").then((r) => setOptions(r.data)).catch(() => {});
  }, []);

  const update = (k, v) => setFilters((s) => ({ ...s, [k]: v }));
  const activeType = filters.deal_type || "";

  // Only show tabs for deal types that have published deals
  const availableTypes = options.deal_types || [];
  const typeTabs = ALL_TYPE_TABS.filter((t) => availableTypes.includes(t.value));
  // Show ALL only when 2+ types exist (redundant with a single type)
  const tabs = typeTabs.length >= 2
    ? [{ value: "", label: "ALL" }, ...typeTabs]
    : typeTabs;

  return (
    <section className="border-y border-[#2A2A2A] bg-[#0B0B0B]" data-testid="filter-bar">
      {/* Deal type tabs — only rendered when there are tabs to show */}
      {tabs.length > 0 && (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 border-b border-[#2A2A2A] flex overflow-x-auto" data-testid="type-tabs">
          {tabs.map((tab) => (
            <button
              key={tab.value}
              onClick={() => update("deal_type", tab.value)}
              className={`shrink-0 px-5 py-3 text-xs font-mono tracking-[0.18em] uppercase transition-colors border-b-2 -mb-px ${
                activeType === tab.value
                  ? "border-[#CC1A1A] text-white"
                  : "border-transparent text-[#555555] hover:text-white"
              }`}
              data-testid={`type-tab-${tab.value || "all"}`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      )}

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-5 flex flex-wrap items-center gap-3">
        <div className="relative flex-1 min-w-[220px]">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#666]" />
          <input
            placeholder="QUERY — destination, airline, route…"
            value={filters.q || ""}
            onChange={(e) => update("q", e.target.value)}
            className="ed-input uppercase tracking-wider text-xs"
            style={{ paddingLeft: "2.5rem" }}
            data-testid="filter-search-input"
          />
        </div>

        <button
          className="md:hidden btn-rd-outline !py-3 !px-4"
          onClick={() => setExpanded((s) => !s)}
          data-testid="filter-toggle"
        >
          <SlidersHorizontal className="w-4 h-4" /> FILTERS
        </button>

        <div className={`${expanded ? "flex" : "hidden"} md:flex flex-wrap gap-3 w-full md:w-auto`}>
          <select
            className="ed-input md:min-w-[160px] uppercase text-xs tracking-wider"
            value={filters.region || ""}
            onChange={(e) => update("region", e.target.value)}
            data-testid="filter-region"
          >
            <option value="">ALL REGIONS</option>
            {options.regions.map((r) => (
              <option key={r} value={r}>{r.toUpperCase()}</option>
            ))}
          </select>

          <select
            className="ed-input md:min-w-[200px] uppercase text-xs tracking-wider"
            value={filters.from_country || ""}
            onChange={(e) => update("from_country", e.target.value)}
            data-testid="filter-from-country"
          >
            <option value="">FROM — ANY COUNTRY</option>
            {options.from_countries.map((c) => (
              <option key={c} value={c}>{c.toUpperCase()}</option>
            ))}
          </select>

          <input
            type="number"
            placeholder="€ MIN"
            className="ed-input md:w-[110px] text-xs"
            value={filters.price_min || ""}
            onChange={(e) => update("price_min", e.target.value)}
            data-testid="filter-price-min"
          />
          <input
            type="number"
            placeholder="€ MAX"
            className="ed-input md:w-[110px] text-xs"
            value={filters.price_max || ""}
            onChange={(e) => update("price_max", e.target.value)}
            data-testid="filter-price-max"
          />
        </div>
      </div>
    </section>
  );
}

